import { User } from './useUser.interface';

import { sendDatadogRumError } from 'utils/analytics/datadogRum';
import zendeskGateway from 'services/help-center/zendeskBackendGateway';

export default async function fetchUser(userId: number): Promise<User> {
    try {
        const response = await zendeskGateway.get<{ user: User }>(`/users/${userId}`);
        return response.data.user;
    } catch (error) {
        sendDatadogRumError('fetchUser', error, { source: 'fetchUser', userId });
        throw new Error('Failed to fetch user data.');
    }
}
